import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { columnGridMixin } from './column-grid-mixin';

export const ColumnGrid = styled.div.attrs({
  className: createReadableClass({
    component: 'column-grid',
    element: 'container'
  })
})`
  ${columnGridMixin}
`;
